<template>
    <div class="page" :class="{'page-member': content.type !== 5}">
        <div class="hd" v-if="content.type !== 5">
            <div class="hd-wrap">
                <!-- <img src="../../assets/wap-bg.png" width=100% alt=""> -->
                <h1>{{content.mainTitle}}</h1>
                <h3>{{content.subName}}</h3>
                <div class="hd-content clearfix">
                    <div class="left">
                        <div class="status" v-show= "content.code === '050411' || content.code === '050406'">
                            <p>已领取</p>
                        </div>
                        <h2>{{content.activityName}}</h2>
                        <h6>{{des}}</h6>
                        <div class="price" v-if="content.reduceAmount > 0">
                            <span class="red">{{units === '元' ? '￥' : ''}}
                                <span class="big">{{content.reduceAmount}}</span>
                                {{units !== '元' ? units : ''}}</span>优惠券</div>
                        <div class="button" :class="{'lignt-btn': (content.code === '050411' || content.code === '050406' || content.code === '0')}" @click="getPower()">{{btnName}}</div>
                    </div>
                    <div class="right">
                        <div class="explain"> 
                            <p style="text-align:center"><img src="../../assets/descript.png" alt=""></p>
                            <div class="des" v-html="content.remark">
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
        <div class="member" v-if="content.type === 5">
            <div class="hd-wrap">
                <h1>{{content.mainTitle}}</h1>
                <h3>{{content.subName}}</h3>
                <div class="member-content">
                    <div class="member-con">
                        <div class="status" v-show= "content.code === '050411' || content.code === '050406'">
                            <p>已领取</p>
                        </div>
                        <h2>{{content.activityName}}</h2>
                        <div class="button" :class="{'lignt-btn': (content.code === '050411' || content.code === '050406' || content.code === '0')}" @click="getPower()">{{btnName}}</div>
                    </div>
                    <div class="explain">
                        <p style="text-align:center"><img src="../../assets/descript.png" alt=""></p>
                        <div class="des" v-html="content.remark">
                        </div>
                    </div>
                </div>
            </div>
        </div> 
        <message-box ref="transfer"></message-box>       
    </div>

</template>
<script>
import {host} from 'env'
import {getCoupon, getCouponPower} from 'api/account'
import messageBox from '../messageBox/alert.vue'
export default {
    data() {
        return {
            content: {},
            title: '',//大标题
            des: '', //描述
            units: '', //单位
            btnName: '立即领取'
        }
    },
    components: {
        messageBox
    },
    created() {
        this.getCouponData()
    },
    methods: {
        // 获取券活动id
        getId() {
            console.log('活动id:' + this.$route.query.id)
            return this.$route.query.id;
        },
        // 获取活动券信息
        getCouponData() {
            if(!this.getId()) {
                console.log('id不存在')
                return;
            }
            getCoupon({id: this.getId()})
                .then((res) => {
                    if(res.data.success) {
                        this.content = res.data.obj;
                        if(this.content.code === '050405') {
                            this.btnName = '活动已结束'
                        } else if(this.content.code === '050406') {
                            this.btnName = '立即使用'
                        }else if(this.content.code === '050410') {
                            this.btnName = '优惠券已失效'
                        }else if(this.content.code === '050411') {
                            this.btnName = '立即使用'
                        }else if(this.content.code === '050412') {
                            this.btnName = '此活动未开始'
                        } 
                        if(this.content.welfareDesc) {
                            this.des = this.content.welfareDesc
                        } else {
                            switch (this.content.type) {
                                case 2:
                                    this.des = `Hi，送您一张权益兑换券`;
                                    break;
                                case 4:
                                    this.des = `Hi，送您一些权益`;
                                    break
                                case 3:
                                    this.des = `Hi，送您一张会员兑换券`;
                                    break
                                case 1:
                                    this.des = `Hi，送您一张优惠券`;
                                    break
                            }
                        }
                        if(this.content.type === 1) {
                            const map = [
                                {
                                    type: 1, units: '秀点', des: '满减券', title: `满${this.content.fullAmount}秀点使用`
                                },
                                {
                                    type: 0, units: '秀点', des: '抵用券', title: `无门槛立减`
                                },
                                {
                                    type: 4, units: '元', des: '现金满减券', title: `满${this.content.fullAmount}元使用`
                                }, 
                                {
                                    type: 5, units: '元', des: '现金抵用券', title: `无门槛立减`
                                },                                                                
                            ];
                            map.filter((f) => {
                                if(f.type === this.content.couponType) {
                                    this.units = f.units;
                                    // this.title = f.title;
                                    // this.des = `Hi，送您一张${this.content.reduceAmount}${this.units}${f.des}`
                                }
                            })                         
                        }
                    } else {
                        Vue.notifier.fail(res.data.msg);
                    }
                })
        },
        getPower() {
            let params = {
                activityId: this.content.id
            };
            if(this.content.code === '050411' || this.content.code === '050406') {
                // Vue.notifier.success('已领取成功，请去账号中心查看')
                this.$refs.transfer.init({type: 'success', title: '已领取成功，请去账号中心查看'})
            } 
            if(this.content.code === '0') {
                getCouponPower(params)
                    .then((res) => {
                        let title = '';
                        let type = 'success'
                        if(res.data.success) {
                            title = '领取成功，请去账号中心查看'
                        } else {
                            type = 'error'
                            title = res.data.msg;
                            if(res.data.code === 60401) {
                                title = '距福利到账仅剩一步，您还没有登录，请登录后再点击领取'
                            }
                            if(res.data.code === 50406) {
                                type = 'received'
                            }
                        }
                        this.$refs.transfer.init({type, title})
                        // Vue.notifier.success(title)
                    })
            }
            
        }
    }
}
</script>
<style lang="scss" scoped>
    // @function px( $px ){
    //     @return $px/$designWidth*10 + rem;
    // }
    // $designWidth : 750; // 750 是设计稿的宽度。 
    $text-color: #4C161D;
        .status {
            width: 6.1rem;
            position: relative;
            margin: 0 auto;
            p{
                background-color: #bfbfbf;
                color: #fff;
                font-size: .26rem;
                padding: 0.2rem;
                text-align: center;
                border-radius: 4px;
                position: absolute;
                right: 0;
            }
        }
    .page{
        background-color: rgba(45, 11, 111, 1);
        &.page-member{
            background-color: #121112;
        }
        .button{
            width: 5.42rem;
            height: 0.96rem;
            font-size: 0.4rem;
            background: #cecece;
            border-radius: 0.48rem;
            color:#fff;
            line-height: 0.96rem;
            cursor: pointer;
            &.lignt-btn{
                color:rgba(188,2,0,1);
                background:linear-gradient(95deg,rgba(255,242,196,1) 0%,rgba(255,210,92,1) 100%);
                &:hover{
                    background:linear-gradient(95deg, rgba(255,210,92,1) 0%,rgba(255,242,196,1) 100%);
                }
            }
        }

    }
    .hd,.member{
        width: 100%;
        margin: 0 auto;
    }
    .hd{
        background: #2F0F73 url(../../assets/wap-light.png) no-repeat;
        background-size: 100%
    }
    .member{
        background: #0F0F10 url(../../assets/member-bg.png) no-repeat center top;
        padding-bottom: 20px;
    }
    .hd-wrap{
        h1{
            font-size: 0.56rem;
            padding-top: 50px;
            font-weight:normal;
            color:rgba(255,255,255,1);
            letter-spacing:1px;
            text-shadow:0px 4px 6px rgba(0,0,0,0.1);
            background:linear-gradient(90deg, rgba(255,242,201,1) 0%, rgba(249,223,144,1) 100%);
            -webkit-background-clip:text;
            -webkit-text-fill-color:transparent;
        }
        h3{
            margin-top: 0.14rem;
            font-size: 0.28rem;
            color: #FFEEB9;
        }
        .hd-content{
            margin-top: 32px;   
            padding-bottom: 30px;
        }
        .left{
            // width: 480px;
            min-height: 405px;
            background: url(../../assets/test.png) no-repeat 0 center;
            background-size: cover;
            position: relative;
            h2{
                color: $text-color;
                font-size: .56rem;
                text-align: left;
                padding-left: 1.2rem;
                padding-top: 28px;
                width: 6rem;
            }
            h6{
                color: $text-color;
                font-size: .26rem;
                font-weight: normal;
                text-align: left;
                padding-left: 1.2rem;
                padding-top: 0.12rem;
                width: 5rem;
                height: 1.3rem;
                overflow: hidden;
            }
            .price{
                color: $text-color;
                font-size: 0.32rem;
                position: absolute;
                left: 1.6rem;
                top: 2.4rem;
                .red{
                    color: #F44033
                }
                .big{
                    font-size: 1.28rem;  
                    font-weight: bold;
                }
            }
            .button{
                position: absolute;
                top: 4.8rem;
                left: 1.2rem;
            }
        }
        .right{
            color: #fff;
            margin: 0 15px;
            background:rgba(66, 73, 160, 0.8);
            border-radius: 4px;
            text-align: left;
            padding: 0 28px 28px;
            position: relative;
            .des{
                min-height: 300px;
            }
        }
    }
    .member-content{
        position: relative;
        background: url(../../assets/wap-hy.png) no-repeat 0 top;
        background-size: contain;
        .member-con{
            height: 6.6rem;
            position:relative;
            .status{
                p{
                    top: 0.5rem;
                    right: -0.05rem;
                }
            }
            h2{
                color: #8C3208;
                font-size: .48rem;
                padding-top: 2rem;
                width: 5.8rem;
                margin: 0 auto;
            }
            .button{
                position: absolute;
                bottom: 1.5rem;
                margin-left: -2.71rem;
                left: 50%;
            }
        }
        .explain{
            margin: 30px 15px 0;
            padding: 0 28px 28px 28px;
            text-align: left;
            background: rgba(88, 83, 76, 0.8);
            border-radius: 4px;
            .des{
                min-height: 100px;
                max-height: 380px;
            }
        }
    }
        .explain{
            p{
                font-size: 20px;
                height: 64px;
                line-height: 64px;
                padding-bottom: 18px;
                color: #fff;
            }
            .des{
                font-size: .28rem;
                color: #FCEAEC;
                
                overflow-y: auto
            }
        }
</style>


